import { Directive, HostBinding } from '@angular/core';
import { clsx } from 'clsx';

@Directive({
  selector: '[sidebarRequestItem]',
})
export class SidebarRequestItemDirective {
  @HostBinding('class')
  class = clsx('border-0 border-b-2 border-solid border-default px-3 py-4 text-default');
}
